<template>
    <v-container grid-list-md fluid>
        
        <confirmation
            :visible="isRemoveRecipe"
            :message="'Are you sure to remove?'"
            @clicked="onConfirmRemoveRecipe($event)"
            @close="isRemoveRecipe=false;"
            />

        <v-layout row wrap>
            <v-flex xs12 sm6 md6 lg6 class="text-left float-left">
                <v-text-field v-model="search" autofocus  append-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <!-- Search By Date -->
            <v-flex  xs12 sm6 md2 lg2 class="float-left">
                <v-layout row wrap>
                    <v-flex xs12 sm12 md12 lg12>
                        <v-menu
                        ref="menuPublishStart"
                        :close-on-content-click="false"
                        v-model="menuPublishStart"
                        :nudge-right="0"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                        >
                            <v-text-field
                                slot="activator"
                                v-model="filterStartDateFormatted"
                                label="Start Date"
                                hint=""
                                persistent-hint
                                @change="filterPublishStartDate = parseMMDDYYDate(filterStartDateFormatted)"
                            ></v-text-field>
                            <v-date-picker v-model="filterPublishStartDate" no-title @input="menuPublishStart = false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex  xs12 sm6 md2 lg2 class="float-left">
                <v-layout row wrap>
                    <v-flex xs12 sm12 md12 lg12>
                        <v-menu
                        ref="menuPublishEnd"
                        :close-on-content-click="false"
                        v-model="menuPublishEnd"
                        :nudge-right="0"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                        >
                            <v-text-field
                                slot="activator"
                                v-model="filterEndDateFormatted"
                                label="End Date"
                                hint=""
                                persistent-hint
                                @change="filterPublishEndDate = parseMMDDYYDate(filterEndDateFormatted)"
                            ></v-text-field>
                            <v-date-picker v-model="filterPublishEndDate" no-title @input="menuPublishEnd = false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex  xs12 sm6 md2 lg2 class="float-left">
                <v-select
                    :items="recipeTypesItems"
                    v-model="typeFilter"
                    label="Type"
                    single-line
                ></v-select>
            </v-flex>
            <v-flex  xs12 sm6 md2 lg2 class="float-left">
                <v-select
                    :items="skillLevelItems"
                    v-model="skillFilter"
                    label="Skill"
                    single-line
                ></v-select>
            </v-flex>
            <v-flex  xs12 sm6 md2 lg2 class="float-left">
                <v-select
                    :items="timeItems"
                    v-model="timeFilter"
                    label="Time"
                    single-line
                ></v-select>
            </v-flex>
            <v-flex  xs12 sm6 md2 lg2 class="float-left">
                <v-btn class="float-right" depressed color="default" @click="clearFilter()">Clear</v-btn>
            </v-flex>
        </v-layout>

        <!-- Loading -->
        <v-layout row v-if="isLoadingRecipes == true">
            <v-flex class="text-xs-center">
                <v-progress-circular :size="50" indeterminate color="default"></v-progress-circular>
            </v-flex>
        </v-layout>
        
        <!-- Not Found -->
        <v-layout row v-if="isLoadingRecipes == false && (!recipes || recipes.length <= 0)">
            <v-flex class="text-xs-center">
                <h4>No recipes found!</h4>
            </v-flex>
        </v-layout>
        
        <!-- Results -->
        <v-flex v-if="recipes.length > 0">
            <v-data-table :headers="headers" :items="recipes" :search="search"  :pagination.sync="pagination" light>
                
                <!-- Recipe List -->
                <template slot="items" slot-scope="props">
                    <td class="text-xs-left">
                        <router-link  class="no-decoration blue--text pointer" :to="{ name: 'EditRecipe', params: { id: props.item.id }}">{{ props.item.name }}</router-link>
                    </td>
                    <td class="text-xs-left">{{ props.item.type }}</td>
                    <td class="text-xs-left">{{ props.item.skill_level }}</td>
                    <td class="text-xs-left">{{ props.item.cook_time }}</td>
                    <td class="text-xs-left">{{ parseFirebaseTimestamp(props.item.published_date) }}</td>
                    <td class="text-xs-left">
                        <v-btn danger block large class="error" @click="isRemoveRecipe = true; removeRecipeId = props.item.id">
                            Remove
                        </v-btn>
                    </td>
                </template>

                <!-- Pagination -->
                <template slot="pageText" slot-scope="{ pageStart, pageStop }">
                From {{ pageStart }} to {{ pageStop }}
                </template>

                <!-- Notifications -->
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
                </v-alert>

            </v-data-table>
        </v-flex>
    </v-container>
</template>

<script>
    import confirmation from "@/components/common/Confirmation.vue";
    import RecipeService from "@/services/db/RecipeService.js";
    import CONSTANT from "@/services/Constant.js";
    import Utils from "@/services/Utils.js";
    import SettingService from "@/services/db/SettingService.js";

    export default {
        name: "Recipes",
        components: {
            confirmation
        },
        data() {
            return {
                title: "Recipes",
                search: "",
                isRemoveRecipe: false,
                removeRecipeId: "",
                recipeTypesItems: CONSTANT.LIST.RECIPE_TYPES,
                skillLevelItems: [],
                timeItems: CONSTANT.LIST.TIME_LIST,
                typeFilter: "",
                skillFilter: "",
                timeFilter: "",
                menuPublishStart: false,
                filterPublishStartDate: null,
                filterStartDateFormatted: null,
                menuPublishEnd: false,
                filterPublishEndDate: null,
                filterEndDateFormatted: null,
                pagination: {
                    page: 1,
                    rowsPerPage: -1,
                    totalItems: 0
                },
                headers: [{
                        text: "Name",
                        align: "left",
                        value: "name"
                    },
                    {
                        text: "Type",
                        align: "left",
                        value: "type"
                    },
                    {
                        text: "Skill",
                        align: "left",
                        value: "skill_level"
                    },
                    {
                        text: "Time",
                        align: "left",
                        value: "cook_time"
                    },
                    {
                        text: "Pub (date)",
                        align: "left",
                        value: "published_date"
                    },
                    {
                        text: "Action",
                        align: "left",
                        value: ""
                    }
                ],
                recipes: [],
                isLoadingRecipes: true
            };
        },
        created() {
            this.loadRecipes();
            this.loadSettingsByKey(CONSTANT.APP_SETTING_KEYS.SKILL_LEVEL);
        },
        watch: {
            typeFilter: function() {
                this.loadRecipes();
            },
            skillFilter: function() {
                this.loadRecipes();
            },
            timeFilter: function() {
                this.loadRecipes();
            },
            // reload stats when filter date changes
            filterPublishStartDate: function(newVal) {
                this.filterStartDateFormatted = Utils.formatMMDDYYYYDate(newVal);
                if(this.filterStartDateFormatted && this.filterEndDateFormatted){
                    this.loadRecipes();
                }
            },
            filterPublishEndDate: function(newVal) {
                this.filterEndDateFormatted = Utils.formatMMDDYYYYDate(newVal);
                if(this.filterStartDateFormatted && this.filterEndDateFormatted){
                    this.loadRecipes();
                }
            }
        },
        methods: {
            /*
             * Method to load recipes
             */
            loadRecipes() {
                this.isLoadingRecipes = true;
                var _USER = JSON.parse(this.$store.getters.loginUser);

                RecipeService.getRecipes(
                    this.typeFilter,
                    this.skillFilter,
                    this.timeFilter,
                    this.filterStartDateFormatted,
                    this.filterEndDateFormatted,
                    _USER.userId,
                    recipes => {
                        this.recipes = [];
                        this.isLoadingRecipes = false;
                        if (recipes) {
                            recipes.forEach(doc => {
                                var _obj = doc.data();
                                _obj["id"] = doc.id;
                                this.recipes.push(_obj);
                            });
                        }
                    }
                );
            },

            /*
             * Method to load setting value by key
             */
            loadSettingsByKey(key) {
                SettingService.getSettingByKey(key).then(setting => {
                    if (setting) {
                        if (key == CONSTANT.APP_SETTING_KEYS.SKILL_LEVEL) {
                            this.skillLevelItems = setting.list;
                        }
                    }
                });
            },

            // Method to remove image after user confirmation
            onConfirmRemoveRecipe(value){
                if(value && this.removeRecipeId){
                    RecipeService.removeRecipeById(this.removeRecipeId)
                    .then(() => {
                        this.$store.commit("setAlert", {
                            isAlertSuccess: true,
                            message: CONSTANT.MESSAGES.RECIPE.REMOVE_SUCCESS
                        });
                    })
                    .catch(() => {
                        this.$store.commit("setAlert", {
                            isAlertError: true,
                            message: CONSTANT.MESSAGES.RECIPE.REMOVE_FAIL
                        });
                    });
                } else {
                    this.removeRecipeId = "";
                }
            },

            /*
             * Method to clear filter values
             */
            clearFilter() {
                this.typeFilter = null;
                this.skillFilter = null;
                this.timeFilter = null;
                this.filterPublishStartDate = null;
                this.filterPublishEndDate = null;
                this.filterStartDateFormatted = null;
                this.filterEndDateFormatted = null;
                this.loadRecipes();
            },

            /*
             * Method to redirect to add recipe page
             */
            goToAddRecipe() {
                this.$router.push("/addRecipe");
            },

            /*
             * Method to parse firebase timestamp date
             */
            parseFirebaseTimestamp(date) {
                return date && date.seconds ?
                    Utils.getFullFormatedDate(date.seconds * 1000) :
                    "";
            },

            // Method to get full formated Date
            parseMMDDYYDate(date) {
                return Utils.parseMMDDYYDate(date);
            }
        }
    };
</script>